import React from 'react';
import styled, { css } from 'styled-components';
import { size } from 'polished';
import screen from 'superior-mq';
import { hover, bp } from 'Styles/helpers';

const PlayButton = props => (
  <StyledPlay {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 24" fill="#fff" width="12" height="24">
      <path d="M12 12L0 0v24z" />
    </svg>
  </StyledPlay>
);

const StyledPlay = styled.button`
  ${size('94px')}
  appearance: none;
  background-color: ${props => props.theme.black};
  border-radius: 50%;
  border: 0;
  transition: transform .4s ease;
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    margin-left: 4px;
    transform: translateZ(1px);
  }

  ${hover('transform: scale(1.1) !important;')}

  ${screen.below(bp.mobile, css`
    width: 62px;
    height: 62px;
    color: black;

    svg {
      width: 7px;
      height: 14px;
      margin-left: 2px;
    }
  `)}
`;

export default PlayButton;
